import { getPubShorthand } from "@components/Modules/AffiliatesMarketingWidget/utils";
import { AffiliateMarketingProvider } from "@sphtech/affiliate-marketing-library";
import { RenderContext } from "@sphtech/web2-core/ssr";
import NeuronProvider from "@web2/providers/NeuronProvider";
import NewRelic from "@web2/providers/NewRelic";
import { ReactElement, StrictMode, useContext } from "react";
import { HelmetProvider } from "react-helmet-async";
import { Outlet, ScrollRestoration } from "react-router";
import { SWRConfig } from "swr";

import { NEURON_CONFIG_NAME } from "./constants";
import AnalyticsSettings from "./utils/AnalyticsSettings";
import { fetcher } from "./utils/swr";

export default function App(): ReactElement {
  const renderContext = useContext(RenderContext);

  return (
    <StrictMode>
      <NeuronProvider configName={NEURON_CONFIG_NAME}>
        <ScrollRestoration />
        <HelmetProvider context={renderContext.helmet}>
          <NewRelic />
          <SWRConfig
            value={{
              fetcher,
            }}
          >
            <AffiliateMarketingProvider
              config={{
                env: import.meta.env.VITE_AM_ENV || "prod",
                pub: getPubShorthand(import.meta.env.VITE_PUBLICATION),
              }}
            >
              <Outlet />
            </AffiliateMarketingProvider>
            <AnalyticsSettings />
          </SWRConfig>
        </HelmetProvider>
      </NeuronProvider>
    </StrictMode>
  );
}
